import React, {ReactElement} from 'react';
import {HistoryButton} from './HistoryButton';
import {SettingsButton} from './SettingsButton';

export const MainMenu = (): ReactElement => {
  return (
    <>
      <HistoryButton />
      <SettingsButton />
    </>
  );
};
